"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const Highcharts = __importStar(require("highcharts"));
const FilterState_1 = __importDefault(require("../components/FilterState"));
const SearchResultPageStore_1 = __importDefault(require("../states/SearchResultPageStore"));
const SearchPage_1 = __importDefault(require("../states/SearchPage"));
const SelectedFiltersStore_1 = __importDefault(require("../states/SelectedFiltersStore"));
const react_progress_bar_1 = __importDefault(require("@ramonak/react-progress-bar"));
const translate_1 = require("../helper/translate");
// Function to chunk the data
const chunkArray = (arr, chunkSize) => {
    const chunks = [];
    for (let i = 0; i < arr.length; i += chunkSize) {
        chunks.push(arr.slice(i, i + chunkSize));
    }
    return chunks;
};
const StackedColumnChart = ({ data, startOffset = 0, chartOptions, setChartConfig, setColors, colors, }) => {
    const chartRef = (0, react_1.useRef)(null);
    const chartInstance = (0, react_1.useRef)(null);
    const [currentData, setCurrentData] = (0, react_1.useState)({ series: [], categories: [] });
    const [dataChunks, setDataChunks] = (0, react_1.useState)([]);
    const [chunkIndex, setChunkIndex] = (0, react_1.useState)(0);
    const memoizedChartOptions = (0, react_1.useMemo)(() => ({
        chart: {
            type: "column",
            width: chartOptions.width,
            height: chartOptions.height,
        },
        title: {
            text: "",
        },
        xAxis: {
            type: "category",
            categories: currentData.categories,
            labels: {
                autoRotation: [-45, -90],
                style: {
                    fontSize: "13px",
                    fontFamily: "Verdana, sans-serif",
                },
            },
        },
        yAxis: {
            min: +startOffset,
        },
        legend: {
            enabled: false,
        },
        tooltip: {
            headerFormat: "<b>{point.key}</b><br/>",
            pointFormat: "{series.name}: <b>{point.fractionString}</b>",
        },
        plotOptions: {
            column: {
                stacking: "normal",
                pointWidth: chartOptions.barWidth,
                pointPadding: chartOptions.barSpacing,
                groupPadding: chartOptions.barSpacing,
                dataGrouping: {
                    enabled: true,
                    groupPixelWidth: 10,
                    approximation: "average",
                },
            },
            series: {
                turboThreshold: 5000, // Adjust based on your dataset size
                animation: false, // Disable animations for performance
            },
        },
        series: currentData.series,
    }), [currentData, chartOptions, startOffset]);
    (0, react_1.useEffect)(() => {
        if (chartRef.current) {
            chartInstance.current = Highcharts.chart(chartRef.current, memoizedChartOptions);
            const initialColors = chartInstance.current.series.map((s) => s.color);
            if (!colors.length) {
                setColors(initialColors);
            }
            const { pointWidth, pointPadding, groupPadding } = chartInstance.current.options.plotOptions.column;
            setChartConfig((prevConfig) => (Object.assign(Object.assign({}, prevConfig), { width: chartInstance.current.chartWidth, height: chartInstance.current.chartHeight, barWidth: pointWidth, barSpacing: pointPadding || groupPadding })));
        }
    }, [memoizedChartOptions, setColors, colors.length]);
    (0, react_1.useEffect)(() => {
        if (chartInstance.current) {
            colors.forEach((color, index) => {
                if (chartInstance.current.series[index]) {
                    chartInstance.current.series[index].update({ color });
                }
            });
        }
    }, [colors]);
    (0, react_1.useEffect)(() => {
        // Chunk the data and initialize the first chunk
        const chunks = chunkArray(data.series, 100); // Adjust the chunk size as needed
        setDataChunks(chunks);
        if (chunks.length > 0) {
            setCurrentData({ series: chunks[0], categories: data.categories });
        }
    }, [data]);
    (0, react_1.useEffect)(() => {
        if (chunkIndex > 0 && chunkIndex < dataChunks.length) {
            setCurrentData((prevData) => ({
                series: [...prevData.series, ...dataChunks[chunkIndex]],
                categories: data.categories,
            }));
        }
    }, [chunkIndex, dataChunks, data.categories]);
    // Simulate progressive data loading
    (0, react_1.useEffect)(() => {
        const interval = setInterval(() => {
            setChunkIndex((prevIndex) => prevIndex + 1);
        }, 1000); // Adjust the interval as needed
        if (chunkIndex >= dataChunks.length) {
            clearInterval(interval);
        }
        return () => clearInterval(interval);
    }, [chunkIndex, dataChunks.length]);
    const progress = (0, react_1.useMemo)(() => {
        return Math.floor(Math.min(((chunkIndex * 100) / data.series.length) * 100, 100)); // Adjust the calculation as needed
    }, [chunkIndex, data.series.length]);
    if (!currentData.categories.length) {
        return null;
    }
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [SearchResultPageStore_1.default.showSummary ? (SearchResultPageStore_1.default.showSummary &&
                (Object.keys(SearchResultPageStore_1.default.summaryFilters).length > 0 ? ((0, jsx_runtime_1.jsx)(FilterState_1.default, { selectedFilters: SearchResultPageStore_1.default.summaryFilters, filters: SearchPage_1.default.filters })) : ((0, jsx_runtime_1.jsx)("div", { dangerouslySetInnerHTML: {
                        __html: `<span style="color: blue;">${(0, translate_1.translate)("Search filters")}: </span> ${(0, translate_1.translate)("None")}`,
                    } })))) : ((0, jsx_runtime_1.jsx)("div", { dangerouslySetInnerHTML: {
                    __html: `<span style="color: blue;">${(0, translate_1.translate)("Search filters")}: </span> ${(0, translate_1.translate)("None")}`,
                } })), (0, jsx_runtime_1.jsx)("div", { dangerouslySetInnerHTML: {
                    __html: SelectedFiltersStore_1.default.statisticsResult,
                } }), progress < 100 && (0, jsx_runtime_1.jsx)(react_progress_bar_1.default, { bgColor: "#189CD8", completed: progress }), (0, jsx_runtime_1.jsx)("div", { ref: chartRef })] }));
};
exports.default = StackedColumnChart;
